// Detecting if the cursor is close to the edge of a resizeable container
$(document).on('mousemove', '.guild-resizeable-width', (event) => {
    const resizeable = $(event.currentTarget);
    // const resizeableWidth = resizeable[0].getBoundingClientRect().width;

    if (event.offsetX < 6) {
        resizeable.addClass('guild-potentially-resizing-width');
    } else {
        resizeable.removeClass('guild-potentially-resizing-width');
    }
});

// Handling the actual resizing
$(document).on('mousemove', (event) => {
    const resizing = $('.guild-is-resizing-width');

    if (resizing.length > 0) {
        const specifiedTarget = resizing[0].getAttribute('data-resizing-target');
        if (specifiedTarget) { // Resizing another element to allow for the resizing
            const toResize = $(specifiedTarget)[0];
            console.log("event.ClientX", event.clientX, "boundingClientRect.left", toResize.getBoundingClientRect().left);
            toResize.style.width = (event.clientX - toResize.getBoundingClientRect().left) + 'px';
        } else { // Resizing this element
            const delta = event.clientX - resizing[0].getBoundingClientRect().left;
            resizing[0].style.width = (resizing[0].getBoundingClientRect().width - delta) + 'px';
        }

        event.preventDefault();
    }
});


// Mouse down do actually potentially resizing
$(document).on('mousedown', '.guild-resizeable-width.guild-potentially-resizing-width', (event) => {
    $(event.currentTarget).addClass('guild-is-resizing-width');
});

$(document).on('mouseup', (event) => {
    $('.guild-is-resizing-width').each((index, element) => {
        $(element).removeClass('guild-is-resizing-width');
    });
});


